export default {
      id: "logout-usage",
      viewBox: "0 0 16.028 16.028",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#logout",
      toString: function () {
        return this.url;
      }
    }